import { Component, OnInit, ElementRef, Renderer2, HostListener, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { map, filter, tap, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import * as _ from 'underscore';
import { NavBarService } from './nav-bar.service';
declare let $: any;

@Component({
    // tslint:disable-next-line:component-selector
    selector: '[nav-bar],nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss'],
    providers: [NavBarService],
    standalone: false
})
export class NavBarComponent implements OnInit {
  obj: any;
  searchVisible = false;
  @ViewChild('srchForm', { static: false }) form: NgForm;

  srchTerm = '';
  searchResults: any;
  constructor(private readonly el: ElementRef, private readonly renderer: Renderer2, private navBarService: NavBarService) { }

  ngOnInit() {
    this.obj = !!sessionStorage.getItem('CURRENT_USER') ? JSON.parse(sessionStorage.getItem('CURRENT_USER')) : null;
    // this.form.valueChanges.pipe(debounceTime(500), distinctUntilChanged())
    // .subscribe((data) => {
    //   if (data.site_search.length > 2) {
    //     this.searchResults = [];

    //     this.navBarService.search(data.site_search).subscribe(resp => {
    //       const categories = _.map(_.uniq(resp, u => u.category),
    //         ele => ele.category);
    //       categories.forEach(category => {
    //         this.searchResults
    //           .push({ category: category, contents: _.filter(resp, ele => ele.category === category) });
    //       });
    //     });

    //   } else {
    //     this.searchResults = [];
    //   }
    // });
  }
  // showSearchBar() {
  //   const target = $('.site-search');

  //   $(target).addClass('search-visible');
  //   setTimeout(() => {

  //     $('.site-search > input').focus();
  //   }, 200);
  // }
  // hideSearchBar() {
  //   const target = $('.site-search');
  //   $(target).removeClass('search-visible');
  // }

}


